import React, { FC } from "react";
import { Helmet } from "react-helmet-async";
import SocialsList from "shared/SocialsList/SocialsList";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
// import BackgroundSection from "components/BackgroundSection/BackgroundSection";
// import SectionPromo1 from "components/SectionPromo1";

export interface PageContactProps {
  className?: string;
}
const info = [
  {
    title: "🗺 ADDRESS",
    desc: "1/1069, Dhobi Sheri, Nanpura, Surat, Gujarat 395001",
    href: "https://www.google.com/maps/search/?api=1&query=1/1069%2C+Dhobi+Sheri%2C+Nanpura%2C+Surat%2C+Gujarat+395001",
  },
  {
    title: "💌 EMAIL",
    desc: "info@meetsolution.in",
    href: "mailto:info@meetsolution.in",
  },
  {
    title: "☎ PHONE",
    desc: "098241 91662",
    href: "tel:09824191662",
  },
];

const PageContact: FC<PageContactProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
      <Helmet>
        <title>Contact Us - Meet Solution</title>
      </Helmet>

      <div className="container py-16 lg:pb-28 lg:pt-20">
        {/* HEADING */}
        <div className="max-w-2xl mx-auto text-center mb-16">
          <h2 className="text-4xl font-semibold">Contact Us</h2>
          <span className="block mt-4 text-neutral-500 dark:text-neutral-400">
            We'd love to hear from you. Send us a message and we'll respond as
            soon as possible.
          </span>
        </div>

        {/* COMPANY INTRODUCTION - Enhanced Paragraph UI */}
        <div className="max-w-5xl mx-auto mb-16">
          <div className="bg-gradient-to-r from-primary-50 to-blue-50 dark:from-primary-900/20 dark:to-blue-900/20 rounded-2xl p-8 lg:p-12 border border-primary-200 dark:border-primary-800 shadow-lg">
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold text-primary-800 dark:text-primary-200 mb-3">
                About Meet Solution Incorporation
              </h3>
              <div className="w-20 h-1 bg-primary-600 mx-auto rounded-full"></div>
            </div>
            <div className="bg-white dark:bg-neutral-800 rounded-xl p-6 lg:p-8 shadow-inner">
              <p className="text-lg text-neutral-700 dark:text-neutral-300 leading-relaxed text-center font-medium">
                At Meet Solution Incorporation, we are always ready to assist you with your security and surveillance needs. Whether you're looking for expert advice, product information, or professional installation services, our team is here to help. Visit us at our head office located at 1/1069, Dhobi Sheri, Nanpura, Surat, Gujarat – 395001, or reach out to us through our contact channels. You can call, email, or connect with us through our website to discuss your requirements or request a customized quotation. We value every customer and strive to provide quick, reliable, and professional support to ensure your complete satisfaction.
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-14">
            {/* CONTENT INFOR */}
            <div className="max-w-sm">
              <h3 className="text-2xl font-semibold mb-4">Keep in touch</h3>
              <span className="block text-neutral-500 dark:text-neutral-400 mb-8">
                We are here to help and answer any question you might have. We
                look forward to hearing from you.
              </span>

              <div className="space-y-5">
                {info.map((item, index) => (
                  <div key={index} className="flex items-center space-x-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-primary-100 dark:bg-primary-900 rounded-lg flex items-center justify-center">
                      <div className="text-2xl">{item.title.split(' ')[0]}</div>
                    </div>
                    <div className="flex-grow">
                      <h4 className="font-medium text-neutral-900 dark:text-neutral-100">
                        {item.title.replace(/^[^\s]+\s/, '')}
                      </h4>
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block mt-1 text-neutral-500 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-400"
                      >
                        {item.desc}
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* FORM */}
            <div className="max-w-lg">
              <form className="grid grid-cols-1 gap-6" action="#" method="post">
                <label className="block">
                  <Label>Name</Label>
                  <Input placeholder="Example Doe" type="text" />
                </label>
                <label className="block">
                  <Label>Email address</Label>
                  <Input placeholder="example@example.com" type="email" />
                </label>
                <label className="block">
                  <Label>Message</Label>
                  <Textarea rows={6} placeholder="Enter your message here..." />
                </label>
                <div>
                  <ButtonPrimary type="submit">Send Message</ButtonPrimary>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageContact;